export default {
  setList (state, { items, total }) {
    state.list = items
    state.total = total
  },

  toggle () {}
}
